import { MISSING_VALUE } from '@constants/stats';
import { Chip } from '@mui/material';
import { formatters, ValueInput } from '@utils/formattersV2';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

const optimizationColor = (value: number) => {
  if (value < 0) return unifiedPlatformColorPalette.lightError;
  if (value > 1) return unifiedPlatformColorPalette.lightSuccess;
  return unifiedPlatformColorPalette.lightWarning;
};

type OptimizationIndexChipProps = {
  value: ValueInput;
};

export const OptimizationIndexChip = (props: OptimizationIndexChipProps) => {
  const { value } = props;

  if (typeof value !== 'number') return MISSING_VALUE;

  return (
    <Chip
      sx={{
        backgroundColor: optimizationColor(value ?? 0),
        color: 'white',
      }}
      size="small"
      label={formatters.number(value, { decimals: 2 })}
    />
  );
};
